import { Component, Output, EventEmitter, HostListener, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './topbar.html',
  styleUrl: './topbar.scss'
})
export class Topbar {
  @Output() menuToggle = new EventEmitter<void>();

  auth = inject(AuthService);

  notificationDropdownOpen = false;
  profileDropdownOpen = false;

  constructor(private readonly router: Router) {}

  toggleNotificationDropdown(): void {
    this.notificationDropdownOpen = !this.notificationDropdownOpen;
    this.profileDropdownOpen = false;
  }

  toggleProfileDropdown(): void {
    this.profileDropdownOpen = !this.profileDropdownOpen;
    this.notificationDropdownOpen = false;
  }

  logout(): void {
    localStorage.removeItem('token');
    this.router.navigate(['/auth/login']);
  }

  @HostListener('document:click')
  closeDropdowns(): void {
    this.notificationDropdownOpen = false;
    this.profileDropdownOpen = false;
  }
}
